import styled from 'styled-components'

const Wrapper = styled.main`
  padding: 10px;
`
const Container = styled.div`
  margin-bottom: 60px;
`
const Main = styled.section`
  display: flex;
`

export { Wrapper, Container, Main }
